var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSlide === _vm.index),expression:"currentSlide === index"}],staticClass:"carousel-items"},[_c('img',{attrs:{"src":_vm.slide.url,"alt":"","loading":"eager"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }